export default __webpack_public_path__ + "static/media/RIFERIMENTIICONA.09c8fbbd.svg";